import { useEffect, useState } from 'react';
import { Link, useNavigate } from '@tanstack/react-router';
import { takeOAuthReturn } from '@/lib/admin/connections';
import { ArrowLeft, CheckCircle2, AlertCircle } from 'lucide-react';

/**
 * Page de retour OAuth réseaux sociaux (cible de la redirection 302 de
 * `social-oauth-callback`). Le callback ne peut PAS rendre de HTML sur le domaine
 * `*.functions.supabase.co` (CSP sandbox de la plateforme Edge) → il redirige ici
 * avec `?status=ok|error&message=…`. On affiche le résultat puis on renvoie au blog.
 */
export function TutorAdminSocialConnectedPage() {
  // SPA client-only : lecture directe des query params de la redirection.
  const [{ ok, message }] = useState(() => {
    const sp = new URLSearchParams(window.location.search);
    return { ok: sp.get('status') !== 'error', message: sp.get('message') ?? '' };
  });
  const navigate = useNavigate();
  // connexion lancée depuis « Paramètres de connexion » : on y retourne
  useEffect(() => {
    if (takeOAuthReturn({ ok, message: message || undefined }))
      void navigate({ to: '/tutor/admin/connexions', replace: true });
  }, [ok, message, navigate]);

  return (
    <div className="mx-auto max-w-md p-4 sm:p-6">
      <Link
        to="/tutor/blog"
        className="text-ink-500 hover:text-ink-900 mb-4 inline-flex items-center gap-1.5 font-sans text-[13px] transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        Blog réflexif
      </Link>

      <div className="border-ink-200 rounded-2xl border bg-white p-6 text-center">
        {ok ? (
          <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-500" />
        ) : (
          <AlertCircle className="text-accent-500 mx-auto h-10 w-10" />
        )}
        <h1 className="font-display text-ink-900 mt-3 text-xl font-extrabold">
          {ok ? 'Compte connecté' : 'Connexion échouée'}
        </h1>
        <p className="text-ink-500 mx-auto mt-2 max-w-sm font-sans text-sm">
          {message
            ? message
            : ok
              ? 'Le réseau est lié. Tu peux maintenant publier tes articles depuis l’éditeur (section « Publier sur les réseaux »).'
              : 'La connexion n’a pas abouti. Vérifie les accès et réessaie.'}
        </p>
        <Link
          to="/tutor/blog"
          className="bg-primary-500 font-display hover:bg-primary-600 mt-6 inline-flex h-11 items-center justify-center gap-2 rounded-xl px-6 text-sm font-bold text-white shadow-md transition-all active:scale-[.98]"
        >
          Retour aux articles
        </Link>
      </div>
    </div>
  );
}
